/* La Bascule — configurateur (sur mesure), packs, guide, panier */
(function () {
  'use strict';
  var B = window.Bascule = window.Bascule || {};

  var COLORS = [
    { name: 'Blanc', hex: '#F2F1EC' }, { name: 'Beige', hex: '#DCC1A6' }, { name: 'Terre cuite', hex: '#C2623F' },
    { name: 'Mandarine', hex: '#F58334' }, { name: 'Jaune citron', hex: '#F0BF3C' }, { name: 'Rouge foncé', hex: '#B31F19' },
    { name: 'Violet', hex: '#966ECE' }, { name: 'Bleu glacier', hex: '#87C6E2' }, { name: 'Bleu marine', hex: '#3580CC' },
    { name: 'Bleu foncé', hex: '#233E65' }, { name: 'Vert kaki', hex: '#5B5E38' }, { name: 'Noir anthracite', hex: '#282826' }
  ];
  var FINISHES = [
    { id: 'lisse', name: 'Lisse', desc: 'Mat et doux au toucher, la base intemporelle.' },
    { id: 'ondes', name: 'Ondes', desc: 'Cercles gravés qui rayonnent autour de la bascule.' },
    { id: 'dunes', name: 'Dunes', desc: 'Lignes souples qui ondulent comme le sable.' },
    { id: 'eventail', name: 'Éventail', desc: 'Des rayons qui partent de la bascule, comme un soleil.' },
    { id: 'strates', name: 'Strates', desc: 'Courbes de niveau organiques, façon carte de relief.' }
  ];
  var FORMATS = { simple: { name: 'Va-et-vient, une touche', short: 'Cache interrupteur' }, prise: { name: 'Prise de courant 2P+T : le centre reste ouvert', short: 'Cache prise' } };
  var EMB = [{ id: 'aucun', name: 'Classique' }, { id: 'galet', name: 'Galet' }, { id: 'feuille', name: 'Feuille' }, { id: 'fleur', name: 'Fleur' }, { id: 'coeur', name: 'Cœur' }];
  var PMAX = 250, WALL = 6, CMAX = PMAX - WALL, CMIN = 40;
  B.COLORS = COLORS; B.FINISHES = FINISHES;

  /* ---------- Utilitaires ---------- */
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  function money(cents) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
  function mm(v) { return (Math.round(v * 10) / 10).toString().replace('.', ','); }
  function hexOf(name) { var c = COLORS.find(function (x) { return x.name === name; }); return c ? c.hex : '#F2F1EC'; }
  function mix(hex, p) {
    var n = parseInt(hex.slice(1), 16), r = n >> 16, g = (n >> 8) & 255, b = n & 255, t = p < 0 ? 0 : 255, a = Math.abs(p);
    return 'rgb(' + Math.round(r + (t - r) * a) + ',' + Math.round(g + (t - g) * a) + ',' + Math.round(b + (t - b) * a) + ')';
  }
  function el(tag, attrs, html) {
    var e = document.createElement(tag);
    Object.keys(attrs || {}).forEach(function (k) { if (k === 'class') e.className = attrs[k]; else if (k === 'style') e.style.cssText = attrs[k]; else e.setAttribute(k, attrs[k]); });
    if (html != null) e.innerHTML = html;
    return e;
  }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function scrollToEl(node) { if (!node) return; node.scrollIntoView({ behavior: B.reducedMotion && B.reducedMotion() ? 'auto' : 'smooth', block: 'start' }); }
  B.money = money;

  /* ---------- Panier ---------- */
  B.updateCartCount = function (count) {
    $$('[data-cart-count]').forEach(function (n) { n.textContent = count; });
  };
  B.addToCart = function (items) {
    return fetch(B.routes.cartAdd, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Erreur'); return j; }); })
      .then(function () { return fetch(B.routes.cart, { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); })
      .then(function (cart) {
        B.updateCartCount(cart.item_count);
        var caches = cart.items.reduce(function (t, it) { return t + (/cache/i.test(it.product_type || '') ? it.quantity : 0); }, 0);
        var msg = 'Ajouté au panier.';
        if (caches > 0 && caches < 3) msg += ' Plus que ' + (3 - caches) + ' cache' + (3 - caches > 1 ? 's' : '') + ' pour le tarif lot et la livraison offerte.';
        else if (caches >= 3 && caches < 5) msg += ' Tarif lot appliqué, livraison offerte. Dès 5 caches : ' + money(B.pricing ? B.pricing.base - B.pricing.lot5Off : 1169) + ' pièce.';
        else if (caches >= 5) msg += ' Meilleur tarif appliqué, livraison offerte.';
        B.toast(msg);
        document.dispatchEvent(new CustomEvent('bascule:cart', { detail: cart }));
        return cart;
      });
  };
  B.toast = function (text) {
    var t = $('#CartToast'); if (!t) return;
    $('[data-toast-text]', t).textContent = text;
    t.hidden = false;
    clearTimeout(B.toastTimer);
    B.toastTimer = setTimeout(function () { t.hidden = true; }, 7000);
  };
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-toast-close]')) { var t = $('#CartToast'); if (t) t.hidden = true; }
  });

  /* ---------- En-tête mobile ---------- */
  document.addEventListener('click', function (e) {
    var close = e.target.closest('[data-menu-close]');
    if (close) { var d = close.closest('details'); if (d) d.removeAttribute('open'); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var d = $('.mobile-nav[open]'); if (d) d.removeAttribute('open');
    if (B.guideModal && B.guideModal.isOpen()) B.guideModal.close();
  });

  /* ---------- Guide de mesure ---------- */
  function GuideUI(root, opts) {
    this.root = root; this.opts = opts || {};
    this.mode = 'simple'; this.brand = 'autre'; this.step = 0; this.playing = true; this.g = null;
    var self = this;
    this.canvas = $('[data-guide-canvas]', root);
    $$('[data-guide-mode]', root).forEach(function (b) { b.addEventListener('click', function () { self.set(b.getAttribute('data-guide-mode'), null); }); });
    $('[data-guide-play]', root).addEventListener('click', function () { self.setPlaying(!self.playing); });
    var done = $('[data-guide-done]', root);
    if (done) done.addEventListener('click', function () { if (self.opts.onDone) self.opts.onDone(); });
    this.render();
  }
  GuideUI.prototype.brands = function () {
    return this.mode === 'double'
      ? [{ id: 'e71', name: 'Entraxe 71 mm (le plus courant)' }, { id: 'e57', name: 'Entraxe 57 mm (rénovation)' }]
      : [];
  };
  GuideUI.prototype.set = function (mode, brand) {
    if (mode) { if (mode !== this.mode) brand = brand || (mode === 'double' ? 'e71' : 'autre'); this.mode = mode; }
    if (brand) this.brand = brand;
    if (this.mode === 'simple') this.brand = 'autre';
    this.step = 0;
    if (this.g) this.g.setBrand(this.mode, this.brand);
    this.render();
  };
  GuideUI.prototype.setPlaying = function (p) {
    this.playing = p;
    if (this.g) this.g.setPlaying(p);
    this.render();
  };
  GuideUI.prototype.start = function () {
    var self = this;
    if (this.g) return;
    var reduced = B.reducedMotion();
    if (reduced) this.playing = false;
    this.render();
    var loading = $('[data-guide-loading]', this.root), fail = $('[data-guide-fail]', this.root);
    if (!B.webglOk()) { loading.hidden = true; fail.hidden = false; return; }
    loading.hidden = false;
    Promise.all([B.loadThree(), B.loadModels('base')]).then(function (r) {
      if (self.g || !self.active) return;
      self.g = new B.Guide(self.canvas, r[1], { mode: self.mode, brand: self.brand, playing: self.playing, reduced: reduced, onStep: function (i) { if (i !== self.step) { self.step = i; self.renderSteps(); } } });
      try { self.g.init(); } catch (err) { console.error(err); self.g = null; fail.hidden = false; }
      loading.hidden = true;
    }).catch(function () { loading.hidden = true; fail.hidden = false; });
  };
  GuideUI.prototype.stop = function () { if (this.g) { this.g.dispose(); this.g = null; } };
  GuideUI.prototype.dims = function () {
    if (this.mode === 'double') { var e = this.brand === 'e57' ? 57 : 71; return { w: 87 + e, h: 87, t: 13, e: e }; }
    return { w: 85, h: 85, t: 13 };
  };
  GuideUI.prototype.stepsData = function () {
    var d = this.dims(), n = function (v) { return (Math.round(v * 100) / 100).toString().replace('.', ','); };
    var dbl = this.mode === 'double', ex = ' (exemple)';
    return dbl ? [
      { title: 'Mesurez la largeur totale', text: 'D’un bord à l’autre de la plaque double, règle à plat, graduation 10 cm calée sur le bord gauche. Retirez 10 cm.', value: n((100 + d.w) / 10) + ' cm − 10 cm = ' + n(d.w) + ' mm' + ex },
      { title: 'Mesurez la hauteur', text: 'Même geste à la verticale, sur le côté de la plaque.', value: n((100 + d.h) / 10) + ' cm − 10 cm = ' + n(d.h) + ' mm' + ex },
      { title: 'Mesurez l’entraxe', text: 'C’est l’écart entre les centres des deux touches (ou des deux prises). Astuce : du bord gauche de la première au bord gauche de la seconde, c’est exactement la même distance.', value: n((100 + d.e) / 10) + ' cm − 10 cm = ' + n(d.e) + ' mm' },
      { title: 'Mesurez l’épaisseur totale', text: 'Touche comprise : règle contre le côté de la plaque, le bout contre le mur. Posez une carte à plat sur la touche et lisez où elle croise la règle.', value: n(d.t) + ' mm' + ex },
      { title: 'Reportez vos cotes', text: 'Notez-les : on cale vos deux fentes et vos deux bascules sur votre entraxe.', value: n(d.w) + ' × ' + n(d.h) + ' mm · entraxe ' + n(d.e) + ' mm' }
    ] : [
      { title: 'Mesurez la largeur', text: 'Règle à plat sur la plaque, graduation 10 cm calée sur le bord gauche. Lisez le bord droit, retirez 10 cm.', value: n((100 + d.w) / 10) + ' cm − 10 cm = ' + n(d.w) + ' mm' + ex },
      { title: 'Mesurez la hauteur', text: 'Même geste à la verticale, sur le côté, loin de la touche.', value: n((100 + d.h) / 10) + ' cm − 10 cm = ' + n(d.h) + ' mm' + ex },
      { title: 'Mesurez l’épaisseur totale', text: 'Touche comprise : règle contre le côté de la plaque, le bout contre le mur. Posez une carte à plat sur la touche et lisez où elle croise la règle.', value: n(d.t) + ' mm' + ex },
      { title: 'Reportez vos cotes', text: 'Entrez-les dans le configurateur, à l’étape « Les cotes de votre plaque » : votre cache est imprimé exactement à ces cotes.', value: 'Votre cache · ' + n(d.w) + ' × ' + n(d.h) + ' mm' + ex }
    ];
  };
  GuideUI.prototype.render = function () {
    var self = this, root = this.root;
    $$('[data-guide-mode]', root).forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-guide-mode') === self.mode)); });
    var wrap = $('[data-guide-brands]', root); wrap.innerHTML = '';
    var list = this.brands();
    wrap.hidden = !list.length;
    list.forEach(function (b) {
      var btn = el('button', { type: 'button', class: 'chip', 'aria-pressed': String(b.id === self.brand) }, esc(b.name));
      btn.addEventListener('click', function () { self.set(null, b.id); });
      wrap.appendChild(btn);
    });
    var play = $('[data-guide-play]', root);
    play.setAttribute('aria-label', this.playing ? 'Mettre l’animation en pause' : 'Lire l’animation');
    $('[data-icon-pause]', play).hidden = !this.playing; $('[data-icon-play]', play).hidden = this.playing;
    $('[data-guide-play-text]', play).textContent = this.playing ? 'Pause' : 'Lecture';
    $('[data-guide-stepcount]', root).textContent = this.mode === 'double' ? '5' : '4';
    $('[data-guide-sizes]', root).textContent = this.mode === 'double'
      ? 'Entraxe le plus courant : 71 mm, parfois 57 mm en rénovation. Valable pour deux interrupteurs, deux prises, ou un interrupteur et une prise côte à côte.'
      : 'Mesurez au millimètre près : chaque cache est imprimé à vos cotes. Entre deux valeurs, gardez la plus grande.';
    var title = document.querySelector('[data-guide-title]');
    if (title && root.closest('.modal')) title.textContent = this.mode === 'double' ? 'Mesurer un double en une minute' : 'Mesurer sa plaque en une minute';
    this.renderSteps();
  };
  GuideUI.prototype.renderSteps = function () {
    var self = this, list = $('[data-guide-steps]', this.root);
    list.innerHTML = '';
    this.stepsData().forEach(function (s, i) {
      var li = el('li');
      var btn = el('button', { type: 'button', class: 'guide__step', 'aria-current': i === self.step ? 'step' : 'false' },
        '<span class="guide__dot">' + (i + 1) + '</span><span style="min-width:0"><strong>' + esc(s.title) + '</strong><span class="t">' + esc(s.text) + '</span><em>' + esc(s.value) + '</em></span>');
      btn.addEventListener('click', function () { self.step = i; if (self.g) self.g.seek(i); self.renderSteps(); });
      li.appendChild(btn); list.appendChild(li);
    });
    $('[data-guide-stepnum]', this.root).textContent = String(this.step + 1);
  };

  function initGuideModal() {
    var modal = $('#GuideModal'); if (!modal) return;
    var ui = new GuideUI($('[data-guide]', modal), { onDone: function () { api.close(); if (api.onDone) api.onDone(); } });
    var lastFocus = null;
    var api = {
      isOpen: function () { return !modal.hidden; },
      open: function (o) {
        o = o || {};
        lastFocus = document.activeElement;
        modal.hidden = false; document.body.classList.add('has-modal');
        ui.active = true;
        ui.set(o.mode || 'simple', o.mode === 'double' ? 'e71' : 'autre');
        ui.start();
        api.onDone = o.onDone || null;
        var c = $('.close-btn', modal); if (c) c.focus();
      },
      close: function () {
        modal.hidden = true; document.body.classList.remove('has-modal');
        ui.active = false; ui.stop();
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      }
    };
    $$('[data-modal-close]', modal).forEach(function (b) { b.addEventListener('click', function () { api.close(); }); });
    modal.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var f = $$('button:not([disabled]), a[href], input, [tabindex="0"]', modal).filter(function (x) { return x.offsetParent !== null && x.tabIndex !== -1; });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    });
    B.guideModal = api;
    // Les liens vers la page Guide des tailles ouvrent la fenêtre (pas de changement de page)
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href]'); if (!a || !B.guideUrl) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
      var path = a.pathname || '';
      if (path === B.guideUrl && location.pathname !== B.guideUrl) {
        e.preventDefault();
        var cfg = B.cfg;
        api.open({ mode: 'simple', onDone: cfg ? function () { cfg.afterGuide(); } : null });
      }
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-open-guide]')) return;
      e.preventDefault();
      var cfg = B.cfg;
      api.open({ mode: 'simple', onDone: cfg ? function () { cfg.afterGuide(); } : null });
    });
  }
  function initInlineGuides() {
    $$('[data-guide][data-inline="true"]').forEach(function (root) {
      var ui = new GuideUI(root, {});
      ui.active = true;
      var go = function () { ui.start(); };
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { io.disconnect(); go(); } }, { rootMargin: '200px' });
        io.observe(root);
      } else go();
    });
  }

  /* ---------- Configurateur (cotes du client uniquement) ---------- */
  function Configurator(root) {
    this.root = root;
    var data = {};
    try { data = JSON.parse($('[data-cfg-data]', root).textContent); } catch (e) { console.error('Données du configurateur illisibles', e); }
    this.data = data; B.pricing = data.pricing;
    var q = new URLSearchParams(location.search);
    var pf = root.getAttribute('data-preset-finish') || q.get('finition') || root.getAttribute('data-default-finish');
    var pfo = root.getAttribute('data-preset-format') || q.get('format') || 'simple';
    var validColor = function (c) { return COLORS.some(function (x) { return x.name === c; }) ? c : null; };
    this.s = {
      cw: '', ch: '', ce: '',
      format: FORMATS[pfo] ? pfo : 'simple',
      finish: FINISHES.some(function (f) { return f.id === pf; }) ? pf : 'eventail',
      color: validColor(q.get('couleur')) || validColor(root.getAttribute('data-default-color')) || 'Terre cuite',
      key: validColor(q.get('bascule')) || validColor(root.getAttribute('data-default-key')) || 'Terre cuite',
      embout: 'aucun', qty: [1, 3, 5].indexOf(parseInt(root.getAttribute('data-default-qty'), 10)) >= 0 ? parseInt(root.getAttribute('data-default-qty'), 10) : 3,
      view: 'apres', night: false, busy: false, error: ''
    };
    if (this.s.format === 'prise' && !this.hasPrise()) this.s.format = 'simple';
    this.viewer = null; this.r3 = 'loading';
    this.build(); this.bind(); this.render(); this.start3d(); this.sticky();
  }
  Configurator.prototype.hasPrise = function () {
    var p = this.data.prise || {};
    return Object.keys(p).some(function (k) { return !!p[k]; });
  };
  Configurator.prototype.build = function () {
    var root = this.root, img = this.data.img || {};
    var fins = $('[data-finishes]', root);
    FINISHES.forEach(function (f) {
      var b = el('button', { type: 'button', class: 'fin-tile', 'data-finish': f.id, 'aria-pressed': 'false' }, '<span class="fin-tile__sw" style="background-image:url(' + esc(img['fin-' + f.id] || '') + ')"></span><span>' + esc(f.name) + '</span>');
      fins.appendChild(b);
    });
    var cols = $('[data-colors]', root), keys = $('[data-keys]', root);
    COLORS.forEach(function (c) {
      cols.appendChild(el('button', { type: 'button', class: 'sw', 'data-color': c.name, 'aria-label': c.name, title: c.name, 'aria-pressed': 'false', style: 'background:' + c.hex }, '<span class="sw__slot"></span><span class="sw__dot"></span>'));
      keys.appendChild(el('button', { type: 'button', class: 'sw sw--key', 'data-key': c.name, 'aria-label': c.name, title: c.name, 'aria-pressed': 'false' }, '<span class="sw__slot"></span><span class="sw__dot" style="background:' + c.hex + '"></span>'));
    });
    var embs = $('[data-embouts]', root);
    EMB.forEach(function (e) {
      var vis = e.id === 'aucun' ? '<span class="emb-classic" data-emb-classic></span>' : '<span class="emb-shape" data-emb-shape style="-webkit-mask-image:url(' + esc(img['emb-' + e.id]) + ');mask-image:url(' + esc(img['emb-' + e.id]) + ');background-image:url(' + esc(img['emb-' + e.id]) + ')"></span>';
      embs.appendChild(el('button', { type: 'button', class: 'emb-tile', 'data-embout': e.id, 'aria-pressed': 'false' }, '<span class="emb-tile__img">' + vis + '</span><span>' + esc(e.name) + '</span>'));
    });
    var tiers = $('[data-tiers]', root);
    [{ n: 1, label: '1 pièce', tag: '' }, { n: 3, label: 'Lot de 3', tag: '' }, { n: 5, label: 'Lot de 5', tag: 'Meilleur prix' }].forEach(function (t) {
      tiers.appendChild(el('button', { type: 'button', class: 'tier', 'data-qty': String(t.n), 'aria-pressed': 'false' }, (t.tag ? '<span class="tier__tag">' + t.tag + '</span>' : '') + '<strong>' + t.label + '</strong><span data-unit></span><small data-save></small>'));
    });
    var p = this.data.pricing || { emb1: 200, emb3: 400, emb5: 600 };
    var hint = $('[data-emb-hint]', root);
    if (hint) hint.textContent = 'En option : +' + money(p.emb1).replace(',00', '') + ' pour 1 cache, +' + money(p.emb3).replace(',00', '') + ' pour 3, +' + money(p.emb5).replace(',00', '') + ' pour 5. Toujours de la couleur de la bascule.';
  };
  Configurator.prototype.bind = function () {
    var self = this, root = this.root;
    root.addEventListener('click', function (e) {
      var t;
      if ((t = e.target.closest('[data-format]'))) self.set({ format: t.getAttribute('data-format'), view: 'apres' });
      else if ((t = e.target.closest('[data-finish]'))) self.set({ finish: t.getAttribute('data-finish'), view: 'apres' });
      else if ((t = e.target.closest('[data-color]'))) self.set({ color: t.getAttribute('data-color'), view: 'apres' });
      else if ((t = e.target.closest('[data-key]'))) self.set({ key: t.getAttribute('data-key'), view: 'apres' });
      else if ((t = e.target.closest('[data-embout]'))) self.set({ embout: t.getAttribute('data-embout'), view: 'apres' });
      else if ((t = e.target.closest('[data-qty]'))) self.set({ qty: parseInt(t.getAttribute('data-qty'), 10) });
      else if ((t = e.target.closest('[data-view]'))) self.set({ view: t.getAttribute('data-view') });
      else if (e.target.closest('[data-toggle]')) { if (self.viewer) self.viewer.toggle(); }
      else if (e.target.closest('[data-reset]')) { if (self.viewer) self.viewer.reset(); }
      else if (e.target.closest('[data-add]') || e.target.closest('[data-sticky-add]')) self.add();
    });
    $$('[data-input]', root).forEach(function (inp) {
      inp.addEventListener('input', function () { self.s[inp.getAttribute('data-input')] = inp.value; self.s.error = ''; self.render(); });
    });
  };
  Configurator.prototype.set = function (o) {
    var s = this.s; Object.keys(o).forEach(function (k) { s[k] = o[k]; });
    if (!('error' in o)) s.error = '';
    this.render();
  };
  Configurator.prototype.measure = function () {
    var s = this.s, w = parseFloat(String(s.cw).replace(',', '.')), h = parseFloat(String(s.ch).replace(',', '.')), e = parseFloat(String(s.ce).replace(',', '.'));
    var ok = !isNaN(w) && !isNaN(h), inRange = ok && w >= CMIN && w <= CMAX && h >= CMIN && h <= CMAX, tooBig = ok && (w > CMAX || h > CMAX);
    return { w: w, h: h, e: isNaN(e) ? null : e, ok: ok, inRange: inRange, tooBig: tooBig };
  };
  Configurator.prototype.dims = function () {
    var m = this.measure();
    if (m.inRange) return { w: Math.min(150, m.w), h: Math.min(150, m.h) };
    return { w: 85, h: 85 };
  };
  Configurator.prototype.sizeLabel = function () {
    var m = this.measure();
    return m.inRange ? 'Sur mesure · ' + mm(m.w) + ' × ' + mm(m.h) + ' mm' : null;
  };
  // Propriétés de commande décrivant la taille (partagées avec les packs)
  Configurator.prototype.sizeProps = function () {
    var m = this.measure();
    if (!m.inRange) return null;
    return { 'Cotes': mm(m.w) + ' × ' + mm(m.h) + ' mm' + (m.e ? ', épaisseur totale ' + mm(m.e) + ' mm (touche comprise)' : '') };
  };
  Configurator.prototype.unit = function (n) {
    var p = this.data.pricing || { base: 1699, lot3Off: 350, lot5Off: 530 }, base = this.basePrice();
    return n >= 5 ? base - p.lot5Off : (n >= 3 ? base - p.lot3Off : base);
  };
  Configurator.prototype.basePrice = function () {
    var prod = this.product(); return prod ? prod.price : ((this.data.pricing && this.data.pricing.base) || 1699);
  };
  Configurator.prototype.embPrice = function (n) {
    var p = this.data.pricing || { emb1: 200, emb3: 400, emb5: 600 };
    return n >= 5 ? p.emb5 : (n >= 3 ? p.emb3 : p.emb1 * n);
  };
  Configurator.prototype.product = function () {
    var s = this.s, grp = s.format === 'prise' ? this.data.prise : this.data.inter;
    return grp ? grp[s.finish] : null;
  };
  Configurator.prototype.variantId = function () {
    var p = this.product(), s = this.s; if (!p) return null;
    return s.format === 'prise' ? p.v[s.color] : p.v[s.color + '|' + s.key];
  };
  Configurator.prototype.matchInfo = function () {
    var m = this.measure();
    if (m.tooBig) return { cls: 'is-error', text: 'Ce cache mesurerait ' + mm(Math.max(m.w, m.h) + WALL) + ' mm : notre imprimante est limitée à ' + PMAX + ' × ' + PMAX + ' mm, soit une plaque de ' + CMAX + ' mm au maximum. Écrivez-nous, on cherche une solution ensemble.' };
    if (!m.ok) return { cls: '', text: 'Entrez la largeur et la hauteur de votre plaque, en millimètres : votre cache est imprimé à ces cotes exactes.' };
    if (!m.inRange) return { cls: 'is-error', text: 'Vérifiez vos cotes : on attend des millimètres, par exemple 86.' };
    return { cls: 'is-ok', text: 'Votre cache sera imprimé pour une plaque de ' + mm(m.w) + ' × ' + mm(m.h) + ' mm. En cas de doute, on vous contacte avant l’impression.' };
  };
  Configurator.prototype.render = function () {
    var s = this.s, root = this.root, self = this, isPrise = s.format === 'prise';
    var fin = FINISHES.find(function (f) { return f.id === s.finish; }) || FINISHES[0];
    var m = this.measure();
    var press = function (sel, attr, val) { $$(sel, root).forEach(function (n) { n.setAttribute('aria-pressed', String(n.getAttribute(attr) === String(val))); }); };
    var mi = this.matchInfo(), match = $('[data-match]', root);
    match.className = 'match ' + mi.cls; match.textContent = mi.text;
    press('[data-format]', 'data-format', s.format);
    $('[data-format-name]', root).textContent = FORMATS[s.format].name;
    press('[data-finish]', 'data-finish', s.finish);
    $('[data-finish-name]', root).textContent = fin.name;
    press('[data-color]', 'data-color', s.color);
    press('[data-key]', 'data-key', s.key);
    $('[data-color-name]', root).textContent = s.color;
    $('[data-key-name]', root).textContent = s.key;
    var keyHex = hexOf(s.key), colHex = hexOf(s.color);
    $$('[data-color]', root).forEach(function (n) { n.classList.toggle('sw--prise', isPrise); $('.sw__dot', n).style.background = keyHex; });
    $$('[data-key]', root).forEach(function (n) { n.style.background = colHex; });
    $('[data-key-step]', root).hidden = isPrise;
    $('[data-emb-step]', root).hidden = isPrise;
    press('[data-embout]', 'data-embout', s.embout);
    var classic = $('[data-emb-classic]', root);
    if (classic) { classic.style.background = 'radial-gradient(circle at 50% 45%, ' + mix(keyHex, 0.12) + ' 0 52%, ' + keyHex + ' 56% 100%)'; classic.style.boxShadow = '0 3px 0 ' + mix(keyHex, -0.3) + ', 0 5px 7px rgba(0,0,0,.25)'; }
    $$('[data-emb-shape]', root).forEach(function (n) { n.style.backgroundColor = keyHex; });
    var embSel = !isPrise && s.embout !== 'aucun' ? EMB.find(function (e) { return e.id === s.embout; }) : null;
    var embSup = embSel ? this.embPrice(s.qty) : 0;
    $('[data-emb-note]', root).textContent = embSel ? embSel.name + ' · +' + money(embSup) : 'Classique · inclus';
    var base = this.basePrice();
    $$('[data-qty]', root).forEach(function (n) {
      var q = parseInt(n.getAttribute('data-qty'), 10), u = self.unit(q), saved = (base - u) * q;
      n.setAttribute('aria-pressed', String(q === s.qty));
      $('[data-unit]', n).textContent = money(u) + ' / pièce';
      $('[data-save]', n).textContent = saved > 0 ? 'Économisez ' + money(saved) : 'Prix unitaire';
    });
    var unit = this.unit(s.qty), total = unit * s.qty + embSup, off = 1 - unit / base;
    var sizeTxt = this.sizeLabel();
    var summary = FORMATS[s.format].short + ' ' + fin.name + ' ' + s.color + (isPrise ? '' : ' / bascule ' + s.key + (embSel ? ' · embout ' + embSel.name : '')) + (sizeTxt ? ' · ' + sizeTxt : ' · taille à indiquer');
    $('[data-summary]', root).textContent = summary;
    $('[data-total]', root).textContent = money(total);
    var detail = s.qty + ' × ' + money(unit) + (off > 0.005 ? ' · −' + Math.round(off * 100) + ' %' : '') + (embSup ? ' + embout ' + money(embSup) : '');
    $('[data-total-detail]', root).textContent = detail;
    var st = $('[data-sticky-total]', root); if (st) { st.textContent = money(total); $('[data-sticky-detail]', root).textContent = s.qty > 1 ? s.qty + ' caches · ' + money(unit) + ' pièce' : fin.name + ' · ' + s.color; }
    var err = $('[data-error]', root); err.hidden = !s.error; err.textContent = s.error || '';
    var add = $('[data-add]', root), blocked = m.tooBig;
    add.disabled = blocked || s.busy;
    add.textContent = blocked ? 'Taille hors limite d’impression' : (s.busy ? 'Ajout en cours…' : (s.added ? 'Ajouté au panier ✓' : 'Ajouter au panier'));
    // Aperçu
    press('[data-view]', 'data-view', s.view);
    var dims = this.dims();
    var cap1 = (s.view === 'avant' ? 'Votre plaque aujourd’hui · ' : (sizeTxt ? 'Sur mesure · ' : 'Taille à préciser · ')) + mm(dims.w) + ' × ' + mm(dims.h) + ' mm';
    $('[data-cap1]', root).textContent = cap1;
    $('[data-cap2]', root).textContent = s.view === 'avant' ? 'Blanc d’origine' : fin.name + ' ' + s.color + (isPrise ? ' · prise visible au centre' : ' · bascule ' + s.key + (embSel ? ' · embout ' + embSel.name : ''));
    var cv = $('[data-canvas]', root);
    cv.setAttribute('aria-label', s.view === 'avant' ? 'Aperçu 3D de votre interrupteur actuel' : 'Aperçu 3D du cache ' + fin.name + ' ' + s.color + (isPrise ? '' : ', bascule ' + s.key + (embSel ? ', embout ' + embSel.name : '')));
    $('[data-note]', root).textContent = this.r3 === 'error' ? 'Aperçu à l’échelle de votre plaque. Le rendu final est mat, coloré dans la masse.' : (isPrise ? 'Aperçu 3D à l’échelle de votre plaque. Glissez pour le faire pivoter : votre prise reste visible au centre.' : 'Aperçu 3D à l’échelle de votre plaque. Glissez pour le faire pivoter. Basculez vers le haut pour passer en mode nuit.');
    var tog = $('[data-toggle]', root); tog.hidden = isPrise || s.view === 'avant';
    var stage = $('[data-stage]', root); stage.classList.toggle('is-night', !!(s.night && this.viewer && !isPrise));
    this.fallback(dims, colHex, keyHex, isPrise);
    this.sync3d();
  };
  Configurator.prototype.fallback = function (dims, colHex, keyHex, isPrise) {
    if (this.r3 !== 'error') return;
    var s = this.s, sc = Math.min(2.7, 300 / dims.w, 300 / dims.h), plate = $('[data-fallback-plate]', this.root), key = $('[data-fallback-key]', this.root);
    var avant = s.view === 'avant', img = (this.data.img || {})['fin-' + s.finish];
    plate.style.width = Math.round(dims.w * sc) + 'px'; plate.style.height = Math.round(dims.h * sc) + 'px';
    plate.style.backgroundColor = avant ? '#F7F6F1' : colHex;
    plate.style.backgroundImage = avant || !img ? 'none' : 'url(' + img + ')';
    plate.style.backgroundSize = 'cover'; plate.style.backgroundBlendMode = 'multiply';
    key.className = isPrise ? 'fallback-plate__hole' : 'fallback-plate__key';
    key.style.background = isPrise ? '#F2F1EC' : (avant ? '#FCFCF9' : keyHex);
  };
  Configurator.prototype.opts3d = function () {
    var s = this.s, d = this.dims();
    return { finish: s.finish, avant: s.view === 'avant', cover: hexOf(s.color), key: hexOf(s.key), w: d.w, h: d.h, embout: s.embout !== 'aucun' && s.format !== 'prise' ? s.embout : null, format: s.format };
  };
  Configurator.prototype.sync3d = function () {
    var self = this;
    if (!this.viewer) return;
    if (this.s.format === 'prise' && !this.viewer.hasCover(this.s.finish + '_p') && !this.loadingPrise) {
      this.loadingPrise = true;
      $('[data-loading]', this.root).hidden = false;
      B.loadModels('prise').then(function (M) { self.viewer.addModels(M); $('[data-loading]', self.root).hidden = true; self.loadingPrise = false; self.sync3d(); })
        .catch(function () { self.loadingPrise = false; $('[data-loading]', self.root).hidden = true; });
    }
    this.viewer.set(this.opts3d());
  };
  Configurator.prototype.start3d = function () {
    var self = this, root = this.root;
    var fail = function () {
      self.r3 = 'error';
      $('[data-canvas]', root).hidden = true; $('[data-loading]', root).hidden = true; $('[data-tools]', root).hidden = true;
      $('[data-fallback]', root).hidden = false;
      self.render();
    };
    if (!B.webglOk()) { fail(); return; }
    var go = function () {
      Promise.all([B.loadThree(), B.loadModels('base')]).then(function (r) {
        self.viewer = new B.Viewer($('[data-canvas]', root), { onNight: function (n) { if (n !== self.s.night) { self.s.night = n; self.updateNight(); } } });
        self.viewer.addModels(r[1]);
        try { self.viewer.init(); } catch (err) { console.error(err); self.viewer = null; fail(); return; }
        self.r3 = 'ok';
        $('[data-loading]', root).hidden = true; $('[data-tools]', root).hidden = false;
        self.render();
      }).catch(function (err) { console.error(err); fail(); });
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { io.disconnect(); go(); } }, { rootMargin: '300px' });
      io.observe($('[data-stage]', root));
    } else go();
  };
  Configurator.prototype.updateNight = function () {
    var root = this.root, n = this.s.night, tog = $('[data-toggle]', root);
    $('[data-stage]', root).classList.toggle('is-night', n);
    $('[data-icon-moon]', tog).hidden = n; $('[data-icon-sun]', tog).hidden = !n;
    $('[data-toggle-text]', tog).textContent = n ? 'Jour' : 'Nuit';
    tog.setAttribute('aria-label', n ? 'Basculer vers le bas : passer en mode jour' : 'Basculer vers le haut : passer en mode nuit');
  };
  Configurator.prototype.afterGuide = function () {
    var step = $('[data-panel="mesure"]', this.root); scrollToEl(step && step.closest('.step'));
    var i = $('[data-input="cw"]', this.root); if (i) setTimeout(function () { i.focus({ preventScroll: true }); }, 350);
  };
  Configurator.prototype.add = function () {
    var self = this, s = this.s;
    if (s.busy) return;
    var size = this.sizeProps();
    if (!size) {
      var m = this.measure();
      this.set({ error: m.tooBig ? 'Cette taille dépasse notre limite d’impression.' : 'Indiquez la largeur et la hauteur de votre plaque à l’étape « Les cotes de votre plaque » : votre cache est fabriqué à ces cotes.' });
      var ms = $('[data-panel="mesure"]', this.root); scrollToEl(ms && ms.closest('.step'));
      var i = $('[data-input="cw"]', this.root); if (i && !m.tooBig) setTimeout(function () { i.focus({ preventScroll: true }); }, 400);
      return;
    }
    var vid = this.variantId();
    if (!vid) { this.set({ error: 'Ce modèle n’est pas encore disponible à la vente. Revenez très vite !' }); return; }
    var fin = FINISHES.find(function (f) { return f.id === s.finish; });
    var props = Object.assign({}, size);
    var items = [];
    var embSel = s.format !== 'prise' && s.embout !== 'aucun' ? EMB.find(function (e) { return e.id === s.embout; }) : null;
    if (embSel) props['Embout'] = embSel.name;
    items.push({ id: vid, quantity: s.qty, properties: props });
    if (embSel) {
      var ev = this.data.embout && this.data.embout.v[embSel.name];
      if (!ev) { this.set({ error: 'Les embouts ne sont pas encore disponibles à la vente.' }); return; }
      items.push({ id: ev, quantity: s.qty, properties: { 'Couleur': s.key, 'Pour': 'Cache ' + fin.name + ' ' + s.color } });
    }
    this.set({ busy: true });
    B.addToCart(items).then(function () { self.set({ busy: false, added: true }); setTimeout(function () { self.s.added = false; self.render(); }, 2500); })
      .catch(function (err) { self.set({ busy: false, error: 'Impossible d’ajouter au panier : ' + err.message }); });
  };
  Configurator.prototype.sticky = function () {
    var root = this.root, bar = $('[data-sticky]', root), card = $('[data-summary-card]', root);
    if (!bar || !('IntersectionObserver' in window)) return;
    var inCfg = false, cardVis = false;
    var upd = function () { var on = inCfg && !cardVis; bar.classList.toggle('is-visible', on); bar.setAttribute('aria-hidden', String(!on)); $('[data-sticky-add]', bar).tabIndex = on ? 0 : -1; };
    new IntersectionObserver(function (es) { inCfg = es[0].isIntersecting; upd(); }).observe($('.cfg__grid', root));
    new IntersectionObserver(function (es) { cardVis = es[0].isIntersecting; upd(); }).observe(card);
  };
  // API pour les autres sections (finitions, packs)
  Configurator.prototype.preset = function (o) {
    if (o && o.format === 'prise' && !this.hasPrise()) o.format = 'simple';
    this.set(Object.assign({ view: 'apres' }, o));
    scrollToEl(this.root);
  };

  /* ---------- Packs ---------- */
  function initPacks() {
    $$('[data-pack]').forEach(function (root) {
      var conf = JSON.parse(root.getAttribute('data-pack'));
      var st = { finish: conf.finish, color: conf.color, key: conf.key, open: false };
      var n = conf.inter + conf.prise;
      var finWrap = $('[data-pack-fins]', root), covWrap = $('[data-pack-covers]', root), keyWrap = $('[data-pack-keys]', root);
      FINISHES.forEach(function (f) { finWrap.appendChild(el('button', { type: 'button', class: 'chip', 'data-pf': f.id, 'aria-pressed': 'false' }, esc(f.name))); });
      COLORS.forEach(function (c) {
        covWrap.appendChild(el('button', { type: 'button', class: 'sw', 'data-pc': c.name, 'aria-label': c.name, title: c.name, 'aria-pressed': 'false', style: 'background:' + c.hex }, '<span class="sw__dot" style="margin:0"></span>'));
        keyWrap.appendChild(el('button', { type: 'button', class: 'sw sw--key', 'data-pk': c.name, 'aria-label': c.name, title: c.name, 'aria-pressed': 'false' }, '<span class="sw__dot" style="margin:0;background:' + c.hex + '"></span>'));
      });
      var render = function () {
        var fin = FINISHES.find(function (f) { return f.id === st.finish; }) || FINISHES[0];
        $$('[data-pf]', root).forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-pf') === st.finish)); });
        $$('[data-pc]', root).forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-pc') === st.color)); $('.sw__dot', b).style.background = hexOf(st.key); });
        $$('[data-pk]', root).forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-pk') === st.key)); b.style.background = hexOf(st.color); });
        $$('[data-pack-item]', root).forEach(function (it) { it.style.background = hexOf(st.color); var i = $('i', it); if (i && !it.classList.contains('is-prise')) i.style.background = hexOf(st.key); });
        $('[data-pack-sel]', root).textContent = fin.name + ' · ' + st.color + (conf.inter ? ' · bascule ' + st.key : '');
        var lines = [];
        if (conf.inter) lines.push('<li><b>' + conf.inter + '×</b> cache interrupteur ' + esc(fin.name) + ' ' + esc(st.color) + ', bascule ' + esc(st.key) + '</li>');
        if (conf.prise) lines.push('<li><b>' + conf.prise + '×</b> cache prise ' + esc(fin.name) + ' ' + esc(st.color) + '</li>');
        $('[data-pack-lines]', root).innerHTML = lines.join('');
        $('[data-pack-edit]', root).hidden = !st.open;
        $('[data-pack-toggle]', root).textContent = st.open ? 'Fermer' : 'Choisir finition et couleurs';
        $('[data-pack-toggle]', root).setAttribute('aria-expanded', String(st.open));
        var p = B.pricing || { base: 1699, lot3Off: 350, lot5Off: 530 };
        var u = n >= 5 ? p.base - p.lot5Off : (n >= 3 ? p.base - p.lot3Off : p.base);
        $('[data-pack-total]', root).textContent = money(u * n);
        $('[data-pack-full]', root).textContent = money(p.base * n);
        $('[data-pack-unit]', root).textContent = '· ' + money(u) + ' / cache';
        $('[data-pack-off]', root).textContent = '−' + Math.round((1 - u / p.base) * 100) + ' %';
        var size = B.cfg && B.cfg.sizeLabel();
        $('[data-pack-size]', root).textContent = size ? 'Taille : ' + size + ' · réglable dans le configurateur' : 'Taille : à indiquer dans le configurateur';
        if (size) { var pm = $('[data-pack-msg]', root); if (pm && /taille/.test(pm.textContent)) pm.hidden = true; }
      };
      root.addEventListener('click', function (e) {
        var t;
        if ((t = e.target.closest('[data-pf]'))) { st.finish = t.getAttribute('data-pf'); render(); }
        else if ((t = e.target.closest('[data-pc]'))) { st.color = t.getAttribute('data-pc'); render(); }
        else if ((t = e.target.closest('[data-pk]'))) { st.key = t.getAttribute('data-pk'); render(); }
        else if (e.target.closest('[data-pack-toggle]')) { st.open = !st.open; render(); }
        else if (e.target.closest('[data-pack-custom]')) {
          e.preventDefault();
          if (B.cfg) B.cfg.preset({ format: conf.inter ? 'simple' : 'prise', finish: st.finish, color: st.color, key: st.key, qty: n >= 5 ? 5 : (n >= 3 ? 3 : 1), embout: 'aucun' });
          else location.href = B.routes.root + '?finition=' + st.finish + '#configurateur';
        }
        else if ((t = e.target.closest('[data-pack-add]'))) {
          var cfg = B.cfg, data = cfg ? cfg.data : null, msg = $('[data-pack-msg]', root);
          if (!data) { location.href = B.routes.root + '#configurateur'; return; }
          var size = cfg.sizeProps();
          if (!size) {
            msg.textContent = 'Indiquez d’abord la taille de votre plaque dans le configurateur, à l’étape « Les cotes de votre plaque » : tout le pack sera fait à cette taille.'; msg.hidden = false;
            cfg.set({ error: 'Indiquez la taille de votre plaque pour ajouter le pack.' });
            var pms = $('[data-panel="mesure"]', cfg.root); scrollToEl(pms && pms.closest('.step'));
            return;
          }
          msg.hidden = true;
          var items = [], ip = data.inter && data.inter[st.finish], pp = data.prise && data.prise[st.finish];
          if (conf.inter) { if (!ip) { msg.textContent = 'Ce pack n’est pas encore disponible.'; msg.hidden = false; return; } items.push({ id: ip.v[st.color + '|' + st.key], quantity: conf.inter, properties: Object.assign({ 'Pack': conf.name }, size) }); }
          if (conf.prise) { if (!pp) { msg.textContent = 'Ce pack sera disponible dès la sortie des caches prise.'; msg.hidden = false; return; } items.push({ id: pp.v[st.color], quantity: conf.prise, properties: Object.assign({ 'Pack': conf.name }, size) }); }
          t.disabled = true; t.textContent = 'Ajout…';
          B.addToCart(items).then(function () { t.textContent = 'Ajouté ✓'; setTimeout(function () { t.disabled = false; t.textContent = 'Ajouter le pack'; }, 2500); })
            .catch(function (err) { t.disabled = false; t.textContent = 'Ajouter le pack'; msg.textContent = err.message; msg.hidden = false; });
        }
      });
      document.addEventListener('bascule:size', render);
      render();
    });
  }

  /* ---------- Liens vers le configurateur ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-cfg-preset]'); if (!t) return;
    var o; try { o = JSON.parse(t.getAttribute('data-cfg-preset')); } catch (err) { return; }
    if (B.cfg) { e.preventDefault(); B.cfg.preset(o); }
  });

  /* ---------- Panier : quantités ---------- */
  function initCart() {
    $$('[data-qty-btn]').forEach(function (b) {
      b.addEventListener('click', function () {
        var inp = b.parentNode.querySelector('input'), v = parseInt(inp.value, 10) || 0;
        inp.value = Math.max(0, v + parseInt(b.getAttribute('data-qty-btn'), 10));
        var f = b.closest('form'); if (f && f.hasAttribute('data-auto-submit')) f.submit();
      });
    });
    $$('form[data-auto-submit] input[type=number]').forEach(function (inp) { inp.addEventListener('change', function () { inp.form.submit(); }); });
  }

  /* ---------- Fiche produit simple (embout) ---------- */
  function initProductForms() {
    $$('[data-product-form]').forEach(function (form) {
      var json = $('[data-variants]', form); if (!json) return;
      var variants = JSON.parse(json.textContent), idInput = $('[name="id"]', form), price = $('[data-price]', form.closest('.product') || document);
      var upd = function () {
        var vals = $$('[data-option]', form).map(function (s) { return s.tagName === 'SELECT' ? s.value : ($('input:checked', s) || {}).value; });
        var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === vals[i]; }); });
        if (v) { idInput.value = v.id; if (price) price.textContent = money(v.price); }
      };
      form.addEventListener('change', upd);
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = $('[type=submit]', form), fd = new FormData(form), props = {};
        fd.forEach(function (val, k) { var m = k.match(/^properties\[(.+)\]$/); if (m && val) props[m[1]] = val; });
        btn.disabled = true;
        B.addToCart([{ id: parseInt(idInput.value, 10), quantity: parseInt(fd.get('quantity') || '1', 10), properties: props }])
          .then(function () { btn.disabled = false; }).catch(function (err) { btn.disabled = false; alert(err.message); });
      });
      upd();
    });
  }

  function boot() {
    initGuideModal();
    initInlineGuides();
    var c = $('[data-configurator]');
    if (c) {
      B.cfg = new Configurator(c);
      var origRender = B.cfg.render.bind(B.cfg), lastSize = null;
      B.cfg.render = function () { origRender(); var sz = B.cfg.sizeLabel(); if (sz !== lastSize) { lastSize = sz; document.dispatchEvent(new CustomEvent('bascule:size')); } };
      if (location.hash === '#configurateur') setTimeout(function () { scrollToEl(c); }, 50);
    }
    initPacks();
    initCart();
    initProductForms();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
